import cn from "classnames";
import FileUpload from "components/modal/fileUpload";
import React from "react";

export default class ImportModal extends FileUpload {
    initialState = {
        paramsRequest: { body: null },
        highlight: false,
        fileName: null,
        result: null,
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading } = this.state;
        if (!isLoading) {
            this.setState({ isLoading: true });
            return this.sendRequest().then((result) => this.setState({ result, isLoading: false }));
        }
    };

    previewFile = (file) => {
        this.setState({ fileName: file.name });
    };

    deletePhoto = () => {
        this.field.value = "";
        this.setState({ paramsRequest: { body: null }, previewImage: null, fileName: null, highlight: false });
    };

    renderActionSend = () => {
        const { body } = this.state.paramsRequest;
        const cname = cn("btn btn-brand btn-sm modal-window__footer-action", { "btn--disabled": !body });
        return <input type="submit" className={cname} value="Загрузить" disabled={!body} />;
    };

    renderFileName = () => {
        return (
            this.state.fileName && (
                <div className="file-upload__preview">
                    <div className="file-upload__file-name">{this.state.fileName}</div>
                    <span onClick={this.deletePhoto} className="close file-upload__delete-button" />
                </div>
            )
        );
    };

    fileUploadResult = () => {
        const { declinedCars, errorCount, successCount } = this.state.result;
        return (
            <div className="row d-block pb-3">
                <h5>Загрузка завершена</h5>
                {successCount > 0 && <div>Назначено трекеров: {successCount}</div>}
                {errorCount > 0 && <div>Не назначено трекеров: {errorCount}</div>}
                {declinedCars && (
                    <div>
                        Машины, которые были отклонены:
                        <ul>
                            {declinedCars.map((num) => (
                                <li key={num}>{num}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    fileUploadArea = () => {
        const { highlight, paramsRequest } = this.state;
        const wrapCname = cn({
            "file-upload__area": true,
            "file-upload__area--highlight": highlight,
            "file-upload__area--filled file-upload__area-file": paramsRequest.body,
        });
        const events = {
            onDragEnter: (e) => this.eventDefault(e, "onDragEnter"),
            onDragOver: (e) => this.eventDefault(e, "onDragOver"),
            onDragLeave: (e) => this.eventDefault(e, "onDragLeave"),
            onDrop: (e) => this.eventDefault(e, "onDrop"),
        };
        return (
            <div className={wrapCname} {...events}>
                <label className="file-upload__input-wrap" title="Выберите файл">
                    <div className="file-upload__drag-icon" />
                    <input
                        ref={(e) => (this.field = e)}
                        type="file"
                        onChange={this.uploadFileByInput}
                        className="file-upload__input"
                    />
                </label>
                {this.renderFileName()}
            </div>
        );
    };

    renderFormActions = () => {
        if (this.state.result) {
            return null;
        }
        return (
            <div className="modal-window__footer modal-window__footer--right">
                {this.renderActionCancel()}
                {this.renderActionSend()}
            </div>
        );
    };

    renderBodyInner = () => {
        return this.state.result ? this.fileUploadResult() : this.fileUploadArea();
    };
}
